module.exports = __webpack_public_path__ + "08_hair_black.e8f42903.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/08_hair_black.png
// module id = hOsp
// module chunks = 0